import React, { useState, useEffect } from "react";
import { Row, Col, Image, Divider, Flex, Skeleton } from "antd";
import { useOutletContext } from "react-router-dom";
import useActions from "./hooks/useActions";
import defaultImage from "../../../../../../../assets/images/png/general/img_thumb_default.png";

// for translate
import { useTranslation } from "react-i18next";

// import styles
import styles from "./styles";

// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

import CourseDescriptionMobile from "./CourseDescriptionMobile";
import ModalDetailCourseMobile from "./modal/ModalDetailCourseMobile";
import { Loader } from "../../../../../../../components/Loader";

const Course = ({ isMobileVersion }) => {
  const { t, i18n } = useTranslation();

  const [outletProps] = useOutletContext();
  const [courseDesc, setCourseDesc] = useState("");
  const {
    journeyId,
    courseId,
    loadingLP,
    loadingLM,
    setListModule,
    setListModuleSupport,
    setLoadingLM,
    mainState,
    reFetchLeftSection,
    setRefetchLeftSection,
    setPercentCompleteCourse,
  } = outletProps;

  const { currCourse } = useActions(
    loadingLP,
    journeyId,
    courseId,
    setListModule,
    setListModuleSupport,
    setLoadingLM,
    mainState,
    reFetchLeftSection,
    setRefetchLeftSection,
    setPercentCompleteCourse,
    isMobileVersion,
  );

  const convertEnter = (desc) => {
    const replacer = desc.replace(/(?:\r\n|\r|\n)/g, "\n");

    setCourseDesc(replacer);
  };

  useEffect(() => {
    if (currCourse.description !== undefined && currCourse.description !== null)
      convertEnter(currCourse.description);
  }, [currCourse]);

  // const screens = useBreakpoint();
  // const isMobileVersion = screens.xs;

  const [isOpenModalDetailCourse, _setOpenModalDetailCourse] = useState(false);

  const setOpenModalDetailCourse = () => {
    _setOpenModalDetailCourse(!isOpenModalDetailCourse);
  };

  const propsCourse = {
    ...currCourse,
    courseDesc,
  };

  return (
    <>
      {isMobileVersion ? (
        <CourseDescriptionMobile
          loading={loadingLM}
          wraperStyle={styles.wrapperStyleMobile}
          rowImageStyle={styles.rowImageStyleMobile}
          index={currCourse.sort}
          thumbnail={currCourse.thumbnail}
          divRightStyle={styles.divRightStyleMobile}
          pProgramStyle={styles.pProgramStyleMobile}
          titleCourseDescStyle={styles.titleCourseDescStyleMobile}
          courseName={currCourse.name}
          rowBottomFirstStyle={null}
          rowBottomSecondStyle={styles.rowBottomSecondStyleMobile}
          pointImageWidth={16}
          totalPoint={null}
          totalCourses={null}
          dividerStyle={styles.dividerStyle}
          description={courseDesc}
          overDue={null}
          setOpenModalDetailCourse={setOpenModalDetailCourse}
          journeyId={journeyId}
        />
      ) : (
        <div style={styles.courseWrapper}>
          <Flex vertical>
            <Flex>
              <div className="w-100" style={styles.courseNameWrapper}>
                <div style={styles.textCourse}>
                  {loadingLM ? (
                    <Skeleton.Input
                      active
                      size={12}
                      style={styles.textCourseSkeleton}
                    />
                  ) : (
                    <>{t("feature.feature_mylj.main_content.course_cap")}</>
                  )}
                </div>
                <div style={styles.courseName}>
                  {loadingLM ? (
                    <Skeleton.Input
                      active
                      size={22}
                      style={styles.courseNameSkeleton}
                    />
                  ) : (
                    currCourse.name
                  )}
                </div>
                <Divider style={styles.divider} />
              </div>
              <div style={styles.divStyle}></div>
            </Flex>
          </Flex>
          <Flex>
            <div className="w-100" style={styles.courseDesc}>
              {loadingLM ? (
                <Skeleton paragraph={{ rows: 10 }} active />
              ) : (
                courseDesc
              )}
            </div>
            <div>
              {loadingLM ? (
                <Skeleton.Avatar
                  active
                  shape="square"
                  style={styles.courseImageSkeleton}
                />
              ) : (
                <Image
                  width={209}
                  height={143}
                  style={styles.courseImage}
                  src={currCourse.thumbnail}
                  preview={false}
                  fallback={defaultImage}
                  alt="Course Thumbnail"
                />
              )}
            </div>
          </Flex>
        </div>
      )}
      <ModalDetailCourseMobile
        isOpen={isOpenModalDetailCourse}
        onClose={setOpenModalDetailCourse}
        data={propsCourse}
      />
    </>
  );
};

export default Course;
